import { CheckmarkFilled, DangerFilled, WarningFilled } from '@icon';
import { ErrorOutline } from '@illustrations';
import { DefaultTheme } from 'styled-components';
import { TPresets, TStatus } from './list-data-line-chart.types';

export const GRADIENTS: Record<TPresets, string> = {
  lifeId:
    'linear-gradient(270deg, #EB4860 6.04%, #F49301 19.91%, #3AD382 35.42%, #3AD382 66.15%, #F49301 79.76%, #EB4860 94.2%)',
  lifeIdPositive: 'linear-gradient(270deg, #3AD382 63.02%, #F49301 75%, #EB4860 88.02%)',
} as const;

export const clamp = (num: number, min: number, max: number) => Math.min(Math.max(num, min), max);

export const getConfigForStatus = (theme: DefaultTheme, status?: TStatus) => {
  if (!status) {
    return undefined;
  }

  switch (status) {
    case 'normal':
      return {
        Icon: CheckmarkFilled,
        color: theme.color.solid.success,
      };
    case 'warn':
      return {
        Icon: WarningFilled,
        color: theme.color.solid.warning,
      };
    case 'attention':
      return {
        Icon: DangerFilled,
        color: theme.color.solid.error,
      };
    default:
      break;
  }
};
